import React, { useState } from "react";
import styles from "../styles/PremiumFSICalculator.module.css";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const PremiumFSICalculator = () => {
  const [converterType, setConverterType] = useState("⁠Premium for Premium FSI");
  const [fsiArea, setFsiArea] = useState("");
  const [reckonerRate, setReckonerRate] = useState("");
  const [premium, setPremium] = useState(null);
  const navigate = useNavigate();

  // Back button
  const handleBack = () => {
    navigate(-1);
  };

  // Dropdown change navigation
  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);

    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };

    if (pathMap[selected]) {
      navigate(pathMap[selected]);
    }
  };

  // Calculate Premium
  const handleCalculate = () => {
    const area = parseFloat(fsiArea);
    const rate = parseFloat(reckonerRate);

    if (isNaN(area) || isNaN(rate)) {
      alert("Please enter valid numbers for both fields.");
      return;
    }

    const result = area * rate * 0.35;
    setPremium(result);
  };

  return (
    <div className={styles.PremiumFSICalculator_container}>
      <div className={styles.PremiumFSICalculator_header}>
        <button className={styles.PremiumFSICalculator_backButton} onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <h2 className={styles.PremiumFSICalculator_title}>Conversion Calculator</h2>
      </div>

      {/* Dropdown */}
      <div className={styles.PremiumFSICalculator_dropdownContainer}>
        <select
          value={converterType}
          onChange={handleDropdownChange}
          className={styles.PremiumFSICalculator_mainDropdown}
        >
          <option>Area Convertor</option>
          <option>Built-up Area Calculator</option>
          <option>Development Charges</option>
          <option>Premium for Ancillary FSI</option>
          <option>⁠Premium for Premium FSI</option>
          <option>ULC Premium</option>
        </select>
      </div>

      {/* Calculator Card */}
      <div className={styles.PremiumFSICalculator_card}>
        <h3 className={styles.PremiumFSICalculator_sectionTitle}>
          Premium Amount for Premium FSI
        </h3>

        <div className={styles.PremiumFSICalculator_formGroup}>
          <label className={styles.PremiumFSICalculator_label}>
            Premium FSI Area (sq.m):
          </label>
          <input
            type="number"
            className={styles.PremiumFSICalculator_input}
            value={fsiArea}
            onChange={(e) => setFsiArea(e.target.value)}
            placeholder="Enter area in sq.m"
          />
        </div>

        <div className={styles.PremiumFSICalculator_formGroup}>
          <label className={styles.PremiumFSICalculator_label}>
            Ready Reckoner Rate (₹/sq.m):
          </label>
          <input
            type="number"
            className={styles.PremiumFSICalculator_input}
            value={reckonerRate}
            onChange={(e) => setReckonerRate(e.target.value)}
            placeholder="Enter rate in ₹/sq.m"
          />
        </div>

        <button
          className={styles.PremiumFSICalculator_submitButton}
          onClick={handleCalculate}
        >
          Submit
        </button>

        <h3 className={styles.PremiumFSICalculator_resultTitle}>Premium</h3>
        <p className={styles.PremiumFSICalculator_resultValue}>
          {premium !== null ? `₹ ${premium.toLocaleString(undefined, { maximumFractionDigits: 2 })}` : "—"}
        </p>
      </div>
    </div>
  );
};

export default PremiumFSICalculator;
